(function(){
    'use strict';

    angular
    .module('appback')
    .controller('CodigosController', CodigosController)
 
    CodigosController.$inject = ["CodigosService","$http","$timeout","$uibModal", "$log", "$document","$sce"];
              
    function CodigosController(CodigosService,$http,$timeout,$uibModal, $log, $document,$sce)
    {                         
        var vm = this;
        vm.grupo_id = "";
        vm.analiticasGrupo = []; 
        vm.analiticas = []; 
        vm.init = function(grupo_id){
        	vm.grupo_id = grupo_id;
	        CodigosService.getCodigosInit(vm.grupo_id,function(data){
	        	vm.analiticas = data.analiticas;
	        	vm.analiticasGrupo = data.analiticasGrupo;
	        })
	    }
    	vm.addGrupo = function(){
    		vm.analiticasGrupo.push({analitica_id:"", descuento:"0.00"});
    	}
    }
  
})();